<template>
  <LayoutProfile>
    <template v-slot:title>{{ $t('menu.profile_resume') }}</template>

    <article class="section-item">
      <header class="section-item__row">
        <div class="section-item__heading">
          <span class="section-item__heading__title">{{ $t('menu.profile_resume') }}</span>
        </div>
      </header>
      <div class="container my-3">
        <div class="row justify-content-between align-items-center profile-user">
          <div class="col-md-5">
            <div class="profile-user__email">
              {{ userData.email }}
            </div>
          </div>
          <div class="col-md-auto">
            <div class="d-md-flex">
              <div class="mr-md-3 mb-2 mb-md-0">
                <b-button variant="light" block :to="{ name: 'profile-change-password' }">
                  {{ $t('menu.profile_change_password') }}
                </b-button>
              </div>
              <div>
                <b-button variant="danger" block class="btn-delete-account" v-b-modal="'modal-delete-account'">
                  {{ $t('menu.delete_account') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- The modal -->
      <b-modal id="modal-delete-account" hide-header centered>
        <div class="text-center mb-2">
          <Icon name="grTrash" width="36" class="mb-3"/>
          <h1 class="modal-title mb-2">{{ $t('modal_delete_account.title') }}</h1>
          <p v-html="$t('modal_delete_account.attention_text')"></p>
          <div class="mb-3">{{ $t('modal_delete_account.enter_password') }}</div>
          <div class="row justify-content-center">
            <div class="col col-lg-7">
              <input-password
                  v-model="password"
                  :required="true"
                  :extra-classes="'mb-2'"
                  :placeholder="$t('forms.login_form.password')"/>
              <div class="errors">
                <div class="items text-danger" v-if="passwordsFieldsRequiredError">
                  {{ $t('modal_delete_account.error_password_required') }}
                </div>
                <div class="items text-danger" v-for="(error, idx) in serverErrors" :key="idx">{{ error }}</div>
              </div>
            </div>
          </div>
        </div>

        <template #modal-footer="{ ok, cancel}">
          <div class="row w-100 justify-content-center">
            <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
              <b-button block variant="primary" @click="deleteAccount()">
                {{ $t('modal_delete_account.action_confirm') }}
              </b-button>
            </div>
            <div class="col-sm-6 order-sm-0">
              <b-button block variant="light" @click="cancel()">
                {{ $t('modal_delete_account.action_cancel') }}
              </b-button>
            </div>
          </div>


        </template>
      </b-modal>

      <b-toast id="toast-delete-account" variant="primary" solid>
        <div class="text-center">
          <h6>{{ $t('notifications.account_deleted_title') }}</h6>
          <div>{{ $t('notifications.account_deleted') }}</div>
        </div>
      </b-toast>


      <footer class="section-item__footer">
        <div class="total-wrapper">
          <div class="items">{{ $t('pages.profile_resume.date_joined') }} {{
              userData.date_joined|formatDateTime
            }}
          </div>
        </div>
      </footer>
    </article>
  </LayoutProfile>
</template>


<script>
import UserService from "@/services/User.js"
import LayoutProfile from "@/components/LayoutProfile"
import InputPassword from "@/components/InputPassword";

export default {
  components: {
    InputPassword,
    LayoutProfile
  },

  data() {
    return {
      userData: {},
      password: null,
      serverErrors: [],
      passwordsFieldsRequiredError: false
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      UserService.getUserData()
          .then(response => {
            this.$set(this, 'userData', response.data)
          })
          .catch(function (error) {
            //console.log(error)
            return error
          })
    },

    deleteAccount() {
      this.serverErrors = []
      this.passwordsFieldsRequiredError = false
      if (!this.password) {
        this.passwordsFieldsRequiredError = true
      } else {
        UserService.deleteAccount(this.password).then(response => {
          this.$nextTick(() => {
            this.$bvModal.hide('modal-delete-account')
          })

          this.$bvToast.show('toast-delete-account')

          // logout
          setTimeout(() => {
            this.$store.dispatch('auth/logout').then(() => this.$router.push('/'))
          }, 3500)

        }).catch(error => {
          if (error.response.status === 400) {
            this.$set(this, 'serverErrors', Object.values(error.response.data).flat())
          }
          return error
        })
      }

    }
  }
}
</script>
